import { DataTypeColumn } from 'components/DataExpansionComponents/Common/commonColumnHelpers'

type InvoiceColumn =
  | 'created'
  | 'amount'
  | 'claim_count'
  | 'due_date'
  | 'status'
  | 'paid_at'

export const INVOICE_COLUMNS: Record<InvoiceColumn, DataTypeColumn> = {
  created: {
    header: 'Date',
    group: 'Invoice Details',
  },
  amount: {
    header: 'Invoice Amount',
    group: 'Invoice Details',
  },
  claim_count: {
    header: '# of Claims',
    group: 'Invoice Details',
  },
  due_date: {
    header: 'SLA Date',
    group: 'Invoice Details',
  },
  status: {
    header: 'Status',
    group: 'Invoice Details',
  },
  paid_at: {
    header: 'Paid At',
    group: 'Invoice Details',
  },
}
